import { render, staticRenderFns } from "./TripsDashboard.vue?vue&type=template&id=360f2469&scoped=true&"
import script from "./TripsDashboard.vue?vue&type=script&lang=js&"
export * from "./TripsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TripsDashboard.vue?vue&type=style&index=0&id=360f2469&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360f2469",
  null
  
)

export default component.exports